import { Button, Col, Form, Row, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { dayjs } from "../../../Utilities/dayjs";
import VoucherServices from "../../Services/VoucherServices";
import { notificationContext } from "../../Common/PageRoute";
import { useClient } from "../../Context/ClientContext";
import { useTheme } from "../../Context/ThemeContext";
import { LockFilled, UnlockFilled } from "@ant-design/icons";
const LockMonth = () => {
  const [form] = Form.useForm();
  const { currentClient, companySettings } = useClient();
  const { themeData } = useTheme();
  const [monthsList, setMonthsList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [trigger, setTrigger] = useState<boolean>(false);
  const [selMonthProps, setSelMonthProps] = useState<any>();
  const { openNotification } = useContext(notificationContext);
  const [selMonthLockType, setSelMonthLockType] = useState<boolean>();
  const LockVoucherMonth = () => {
    try {
      setLoading(true);
      form.validateFields().then(async (val: any) => {
        const lockMonthProps = val.lockMonth;
        setSelMonthProps(lockMonthProps);
        let SelMonthValueLockType = monthsList?.find(
          (mon: any) => mon.value === lockMonthProps?.value
        );
        let res = await VoucherServices.postLockVoucherMonth(
          currentClient?.id!,
          lockMonthProps.value,
          !SelMonthValueLockType?.locked
        );
        if (res.result) {
          setSelMonthLockType(!SelMonthValueLockType?.locked);
          setLoading(false);
          setTrigger((prev: any) => !prev);
        } else {
          openNotification("error", res.message);
          setLoading(false);
        }
      });
    } catch (error) {
      setLoading(false);
    }
  };
  const getMonthsList = async () => {
    const monthsList = await VoucherServices.getLockVoucherMonths(
      currentClient?.id!
    );
    console.log("Months List: ", monthsList?.result);

    if (monthsList !== null) {
      // let startMonth = dayjs(currentClient?.financialYearBegin);
      let currentMonth = dayjs();
      let monthsListOptions: any = [];
      for (
        let startMonth = dayjs(currentClient?.financialYearBegin);
        startMonth.isBefore(currentMonth);
        startMonth = startMonth.add(1, "month") // Reassign `startMonth`
      ) {
        monthsListOptions.push({
          key: dayjs(startMonth).format("DD-MM-YYYY"),
          value: dayjs(startMonth).toISOString(),
          label: (
            <Row>
              <Col span={16} style={{ textAlign: "left" }}>
                {startMonth.format("MMM")}-{startMonth.year()}
              </Col>
              {monthsList?.result?.find(
                (mon: any) =>
                  dayjs(mon.lockedMonth).toISOString() ===
                  dayjs(startMonth).toISOString()
              )?.isLocked ? (
                <Col
                  span={8}
                  style={{
                    color: "red",
                    textAlign: "right",
                    paddingRight: "5px",
                  }}
                >
                  <LockFilled style={{ color: "#F2003C" }} />
                </Col>
              ) : (
                <Col
                  span={8}
                  style={{
                    color: "green",
                    textAlign: "right",
                    paddingRight: "5px",
                  }}
                >
                  <UnlockFilled style={{ color: `${themeData?.themeColor}` }} />
                </Col>
              )}
            </Row>
          ),
          title: "",
          locked:
            monthsList?.result?.find(
              (mon: any) =>
                dayjs(mon.lockedMonth).toISOString() ===
                dayjs(startMonth).toISOString()
            )?.isLocked ?? false,
        });
      }
      setMonthsList(monthsListOptions);
    }
  };
  useEffect(() => {
    getMonthsList();
    if (selMonthProps) {
      form.setFieldValue("lockMonth", selMonthProps?.value);
    }
  }, [currentClient?.id, trigger]);
  console.log("Selected month's value: ", selMonthProps);
  return (
    <Row>
      <Col span={24}>
        <Row>
          <Col>
            <Form form={form} onFinish={LockVoucherMonth}>
              <Form.Item name="lockMonth" label="Select month to lock" required>
                <Select
                  placeholder="Place select a month to lock/unlock"
                  style={{ width: "300px" }}
                  labelInValue
                  options={monthsList}
                  onChange={(val: any) => {
                    let SelMonthValueLockType = monthsList?.find(
                      (mon: any) => mon.value === val?.value
                    );
                    setSelMonthLockType(SelMonthValueLockType.locked);
                  }}
                ></Select>
              </Form.Item>
              <Form.Item>
                <Button loading={loading} type="primary" htmlType="submit">
                  {selMonthLockType ? "Unlock month" : "Lock month"}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default LockMonth;
